const configKeys = {
    SETTINGS: 'settings',
    MARKET_LOCALIZATIONS: 'marketLocalizations',
    CUSTOM_FEATURES: 'customFeatures',
    DEVICE_FEATURES: 'deviceFeatures',
    UWM_CONFIG: 'uwmConfig',
};

export default configKeys;
